import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TableAttrs } from 'book-widgets/interfaces';
import { Generator } from './generator';

import { knownClasses } from './table-util';
import { ColSpecMap } from './table';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

export interface TableHeadRowProperties {
	widths: ColSpecMap;
	entries: TopicDetails[];
	rowattrs: TableAttrs;
}

const factory = create({ theme }).properties<TableHeadRowProperties>();

export const TableHeadRow = factory(({ properties, middleware: { theme } }) => {
	const { widths, entries, rowattrs } = properties();
	const themeCss = theme.classes(css);

	const heads = entries.map((item, idx) => {
		const { attributes = {} as TableAttrs, children = [] } = (item as any).entry;
		const { outputclass, namest = 1, nameend = 1, colname = idx + 1 } = attributes as TableAttrs;
		const name = `col-${colname}`;
		const colspan = namest !== nameend ? `${nameend - namest + 1}` : null;
		const styles = colspan === null ? { width: `${widths.get(name)!.width}rem` } : {};
		const classes = outputclass && knownClasses.has(outputclass) ? [(themeCss as any)[outputclass]] : [];
		return v('th', { styles, colspan, classes }, [
			w(Generator, { topic: { attributes, children }, skipTitle: true, intable: true })
		]);
	});

	const rowsep = rowattrs && rowattrs.rowsep;
	const defaultRowSep = widths.get('tgroup')!.separator || null;
	const separator =
		rowsep === undefined ? defaultRowSep : rowsep === 0 ? themeCss.noRowSeparator : themeCss.rowSeparator;

	const classes = [separator];
	return v('tr', { classes }, heads);
});
